import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'bg-system-gray-100'
  },
  variants: {
    color: {
      primary: 'text-main'
    }
  },
  defaultVariants: {
    color: 'primary'
  }
});
